import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_2 = ["height"]

import { withDefaults, watch, ref, onMounted } from 'vue';
import { MoleculeCard } from '@/components/molecules';
import { AtomToogleButton } from '@/components/atoms';
import Chart, { ChartConfiguration } from 'chart.js/auto';
import { IDataPolarChart, IOptionsSelect, IToggleButon } from '@/types';
interface IProps {
  title: string;
  legend: boolean;
  data: Array<IDataPolarChart>;
  hasToggle?: boolean;
  loading?: boolean;
  buttons?: IToggleButon[];
  hasDropdownList?: boolean;
  optionsDropDown?: IOptionsSelect[];
  height?: number;
  labels?: string[]
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OrganismsPolarChart',
  props: {
    title: { default: '' },
    legend: { type: Boolean, default: false },
    data: null,
    hasToggle: { type: Boolean },
    loading: { type: Boolean },
    buttons: null,
    hasDropdownList: { type: Boolean },
    optionsDropDown: null,
    height: null,
    labels: null
  },
  emits: ['handleToggle', 'onChangeDropDownList'],
  setup(__props: any, { emit }) {

const props = __props as { title: string, legend: boolean, data: Array<IDataPolarChart>, hasToggle?: boolean, loading?: boolean, buttons?: IToggleButon[], hasDropdownList?: boolean, optionsDropDown?: IOptionsSelect[], height?: number, labels?: string[] };

const chartOptions = ref<ChartConfiguration>();
const canvasRadar = ref(null);
const chart = ref<Chart>();





function changeChartOptions() {
  const data = {
    labels: props.labels,
    datasets: props.data.map(f => {
      return {
        fill: true,
        ...f
      }
    })
  };
  chartOptions.value = {
    type: 'radar',
    data: data,
    options: {
      responsive: true,
      plugins: {

      },
      elements: {
        line: {
          borderWidth: 3
        }
      }
    },
  }
  if (chart.value) {
    chart.value.clear();
    chart.value.destroy()
  }
  const dad = document.getElementById("canvasRadar") as HTMLElement;
  dad.style.width = "100%";
  if (!dad) return;
  chart.value = new Chart(canvasRadar.value, chartOptions.value);
  chart.value.resize(props.height, props.height);
}
function handleChangeDropdownList(event) {
  emit('onChangeDropDownList', event);
}

watch(
  () => props.data,
  () => {

    setTimeout(() => {
      changeChartOptions();
    }, 300)

  },
  { deep: true }
);
function handleToogleChange($event) {
  emit('handleToggle', $event);
}
onMounted(() => {

  // setTimeout(() => {
  //   changeChartOptions();
  // }, 300)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(MoleculeCard), {
    textTooltip: 'textTooltip',
    title: props.title,
    loading: props.loading,
    onOnChangeDropDownList: handleChangeDropdownList,
    "has-dropdown-list": props.hasDropdownList,
    "options-drop-down": props.optionsDropDown
  }, {
    default: _withCtx(() => [
      (props.hasToggle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(AtomToogleButton), {
              buttons: props.buttons ?? [],
              onHandleToggle: handleToogleChange
            }, null, 8, ["buttons"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("canvas", {
        id: "canvasRadar",
        width: "100",
        height: props.height,
        ref_key: "canvasRadar",
        ref: canvasRadar
      }, null, 8, _hoisted_2)
    ]),
    _: 1
  }, 8, ["title", "loading", "has-dropdown-list", "options-drop-down"]))
}
}

})